import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Checkbox, Input } from 'common/components';
import { emailRegisterOptions } from 'common/constants';
import { LoginCredentialsFormProps, LoginFormData } from '../Login.types';
import styles from '../Login.module.scss';

const LoginCredentialsForm: React.FC<LoginCredentialsFormProps> = ({
    isLoading,
    error,
    onSubmit,
    onForgotPassword,
}) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isSubmitting },
    } = useForm<LoginFormData>({
        defaultValues: {
            email: '',
            password: '',
            consent: false,
        },
        mode: 'onBlur',
    });

    const busy = isLoading || isSubmitting;

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.loginForm}>
            <Input
                {...register('email', emailRegisterOptions)}
                label='Email'
                type='email'
                placeholder='Enter your email address'
                disabled={busy}
                error={!!errors.email}
                errorText={errors.email?.message}
            />

            <div>
                <Input
                    {...register('password', {
                        required: 'Password is required',
                    })}
                    label='Password'
                    type='password'
                    placeholder='Enter your Password'
                    disabled={busy}
                    error={!!errors.password}
                    errorText={errors.password?.message}
                />
                <div className={styles.forgotRow}>
                    <Button type='button' variant='link' onClick={onForgotPassword} disabled={busy}>
                        Forgot my password
                    </Button>
                </div>
            </div>

            {error && <p className={styles.loginError}>{error}</p>}

            <Controller
                control={control}
                name='consent'
                render={({ field }) => (
                    <Checkbox
                        label='By checking this box, you agree to receive SMS messages from StraightLine AI related to AI agent interactions, including follow-ups, alerts, and system notifications. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out or HELP for help. Consent is not required to use this service.'
                        checked={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        error={!!errors.consent}
                        errorText={errors.consent?.message as string | undefined}
                    />
                )}
            />

            <Button type='submit' variant='primary' disabled={busy} size='md' style={{ marginTop: 'var(--margin-lg)' }}>
                {busy ? 'Logging in...' : 'Log in'}
            </Button>
        </form>
    );
};

export default LoginCredentialsForm;
